module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av331-8da0ee182da145b7dcea81c298676958.jpg";